var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSigliveProcessingState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0513 54.2856C13.3501 54.2856 4.92521 62.7803 5.77377 72.7146L10.6967 130.008C11.4577 138.878 19.4112 145.714 28.9743 145.714H171.026C180.582 145.714 188.536 138.878 189.304 130.008L194.227 72.7146C195.082 62.7871 186.65 54.2856 175.949 54.2856H24.0513Z",
    fill: "#CCE2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5196 155.714C58.4467 155.714 56.6811 154.228 56.3237 152.191L42.9139 76.15C42.7638 75.3067 42.9139 74.4277 43.35 73.6844L48.3965 64.9583C48.9397 64.0221 49.8618 63.3789 50.9269 63.1859L128.205 49.5643C128.455 49.5214 128.705 49.5 128.948 49.5C131.021 49.5 132.786 50.9794 133.144 53.0233L147.79 136.068C147.99 137.19 147.74 138.319 147.083 139.255C146.432 140.192 145.453 140.813 144.331 141.006L61.2701 155.65C61.02 155.693 60.7698 155.714 60.5267 155.714H60.5196Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132.937 109.825L138.677 142.371L67.0393 155L61.2994 122.454C60.9778 120.624 62.2001 118.88 64.03 118.552L129.034 107.088C130.864 106.767 132.608 107.989 132.937 109.818V109.825Z",
    fill: "#D3DEEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5196 155.714C58.4467 155.714 56.6811 154.228 56.3237 152.191L42.9139 76.15C42.7638 75.3067 42.9139 74.4277 43.35 73.6844L48.3965 64.9583C48.9397 64.0221 49.8618 63.3789 50.9269 63.1859L128.205 49.5643C128.455 49.5214 128.705 49.5 128.948 49.5C131.021 49.5 132.786 50.9794 133.144 53.0233L147.79 136.068C147.99 137.19 147.74 138.319 147.083 139.255C146.432 140.192 145.453 140.813 144.331 141.006L61.2701 155.65C61.02 155.693 60.7698 155.714 60.5267 155.714H60.5196Z",
    stroke: "#215AA8",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0293 86.3055C61.7069 86.3055 60.5775 85.355 60.3488 84.0543L56.0957 59.9271L116.447 49.2856L120.7 73.4129C120.829 74.1275 120.664 74.8494 120.25 75.4497C119.835 76.05 119.206 76.4431 118.491 76.5717L63.5011 86.2626C63.3438 86.2912 63.1794 86.3055 63.0222 86.3055H63.0293ZM64.4375 63.8863L67.168 79.3589L75.7529 77.8438L73.0223 62.3712L64.4375 63.8863Z",
    fill: "#7A9CCB",
    stroke: "#215AA8",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M144.079 95.7142C157.606 95.7142 168.572 84.7484 168.572 71.2214C168.572 57.6943 157.606 46.7285 144.079 46.7285C130.552 46.7285 119.586 57.6943 119.586 71.2214C119.586 84.7484 130.552 95.7142 144.079 95.7142Z",
    fill: "#0045A3"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M141.635 93.2714C155.162 93.2714 166.128 82.3055 166.128 68.7785C166.128 55.2515 155.162 44.2856 141.635 44.2856C128.108 44.2856 117.143 55.2515 117.143 68.7785C117.143 82.3055 128.108 93.2714 141.635 93.2714Z",
    fill: "#3378D6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M153.335 74.9427H141.092C139.414 74.9427 138.057 73.5856 138.057 71.907V56.5784C138.057 54.8999 139.414 53.5427 141.092 53.5427C142.771 53.5427 144.128 54.8999 144.128 56.5784V68.8713H153.335C155.014 68.8713 156.371 70.2284 156.371 71.907C156.371 73.5856 155.014 74.9427 153.335 74.9427Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigliveProcessingState);
export default __webpack_public_path__ + "static/media/siglive-processing-state.57ff8ba7efdcc6827738341516366d00.svg";
export { ForwardRef as ReactComponent };